import {inject} from "aurelia-framework";
import {OperationInterface} from "./operation.interface";
import {BulkOperationQueryCore} from "./utility/bulk-operation-query-core";
import {I18N} from "aurelia-i18n";
import {selectEntities} from "../../dialog/universal-entity-select";

@inject(BulkOperationQueryCore, I18N)
export class CreateMarginReportOperation extends OperationInterface {
    constructor(bulkOperationQueryCore, i18n) {
        super()
        this.bulkOperationQueryCore = bulkOperationQueryCore
        this.i18n = i18n
    }

    getName = () => 'create-margin-reports'
    getActions = (items, operationConfig) => [{
        type: 'bulk-operation',
        operationConfig,
        label: this.i18n.tr('costs.create-margin-reports'),
    }]

    async execute(context) {
        const result = await selectEntities('accounting/ledger-account', null, {
            title: 'costs.margin-report-account',
            multiSelect: false,
        })

        if (result.wasCancelled || !result.output?.length) {
            return
        }

        return this.bulkOperationQueryCore.query(
            context.operationConfig.type,
            {
                items: context.items,
                account: result.output[0].id,
            }
        )
    }
}
